import { useLocation, useNavigate } from 'react-router-dom'

import AuthorizeUser from 'modules/core/components/AuthorizeUser'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useGraphQLClient } from 'modules/core/lib/graphql/provider'

import PaymentModalContainer from 'modules/billing/components/PaymentModalContainer'
import Plan from 'modules/billing/store/models/Plan'

const PaymentModalPage = () => {
  const { navigation } = useNavigation()

  const graphQLClient = useGraphQLClient()
  const navigate = useNavigate()
  const location = useLocation()
  const recurrence = new URLSearchParams(location.search).get('recurrence')
  const family = new URLSearchParams(location.search).get('family')
  const isYearly = recurrence === Plan.intervals.year
  const queryFamily = family ?? (Plan.AVAILABLE_FAMILIES.essentials as string)

  const onClose = () => {
    navigate(navigation.upgradePlan.fullPath())
  }

  return (
    <AuthorizeUser>
      <PaymentModalContainer
        graphQLClient={graphQLClient}
        onClose={onClose}
        family={queryFamily}
        isYearly={isYearly}
      />
    </AuthorizeUser>
  )
}

export default PaymentModalPage
